import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  setMemberEditEntrance,
  setMemberPageState,
} from '@actions/member/memberAction';
import { FormattedMessage } from 'react-intl';
import { initMemberInfo } from '@actions/memberInfo/memberInfoAction';
import { useEffect } from 'react';
import PropTypes from 'prop-types';

function MemberMenu({ storeUuid }) {
  const dispatch = useDispatch<any>();
  const isLogin = useSelector<RootStateOrAny, any>(
    (state) => state.memberInfoReducer.isLogin
  );

  const isMember = useSelector<RootStateOrAny, any>(
    (state) => state.memberInfoReducer.isMember
  );

  const memberEnabled = useSelector<RootStateOrAny, any>(
    (state) => state.memberInfoReducer.enabled
  );

  useEffect(() => {
    dispatch(initMemberInfo(storeUuid));
  }, [storeUuid, memberEnabled]);
  const checkLogin = () => {
    if (isLogin) {
      dispatch(setMemberPageState('MemberProfile'));
    } else {
      dispatch(setMemberPageState('MemberOtpValidator'));
      dispatch(setMemberEditEntrance(true));
    }
  };

  if (!memberEnabled) return <div />;

  return (
    <>
      {!isMember && (
        <li className="div-hover">
          <div
            role="presentation"
            style={{
              textAlign: 'center',
              padding: '10px 0px 10px 0px',
            }}
            onClick={() => {
              dispatch(setMemberPageState('MemberLogin'));
            }}
          >
            <FormattedMessage id="common.member.login" />
          </div>
        </li>
      )}

      {isMember && (
        <li className="div-hover">
          <div
            role="presentation"
            style={{
              textAlign: 'center',
              padding: '10px 0px 10px 0px',
            }}
            onClick={checkLogin}
          >
            <FormattedMessage id="common.member.setting" />
          </div>
        </li>
      )}
    </>
  );
}

MemberMenu.propTypes = {
  storeUuid: PropTypes.string.isRequired,
};

export default MemberMenu;
